import { type RouteRecordRaw } from "vue-router";

export enum Routes {
  login = "login",
  password_recovery = "password_recovery",
  password_reset = "password_reset",
  home = "home",
  sessions = "sessions",
  users = "users",
  locations = "locations",
  chargers = "chargers",
  plans = "plans",
  admins = "admins",
  not_found = "not_found",
  connectors = "connectors",
  partnerships = "partnerships",
}

export enum ChildrenRoutes {
  list = "list",
  detail = "detail",
  add = "add",
  edit = "edit",
  general = "general",
  sessions = "sessions",
  info = "info",
  monitoring = "monitoring",
  activity_log = "activity_log",
  partnership_info = "partnership_info",
  chargers = "chargers",
  hours = "hours",
  connectors = "connectors",
}

export type RouteRaw = Omit<RouteRecordRaw, "children"> & {
  [key in ChildrenRoutes]?: RouteRaw;
};

export type RoutesObj = Record<Routes, RouteRaw>;
